import {
    FetchState,
    IndividualSignup
} from "@/shared/types";

import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: IndividualSignup = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    fetchState: FetchState.Uninitialized,
    hsaContributionLimits: {
        familyAmount: 0,
        individualAmount: 0
    },
    partnerId: null,
    isEmployeeSignup: null,
};

export const useSignUpStore = defineStore("signup", {
    state: (): IndividualSignup => (_.cloneDeep(initialState)),
    getters: {
        individualSignupState: state => ({
            firstName: state.firstName,
            lastName: state.lastName,
            email: state.email,
            phone: state.phone,
            fetchState: state.fetchState,
            hsaContributionLimits: state.hsaContributionLimits,
            partnerId: state.partnerId,
            isEmployeeSignup: state.isEmployeeSignup
        }),
        isLoaded: state => state.fetchState === FetchState.Loaded,
        contributionLimits: state => state.hsaContributionLimits,
    },
    actions: {
        setEnrollmentEmail (email: string) {
            this.email = email;
        },
        setContributionLimits (value) {
            this.hsaContributionLimits = value;
            this.fetchState = FetchState.Loaded;
        },
        signupIndividual: (individualSignup): Promise<any> => {
            return UserService.createIndividualSignup(individualSignup)
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
        resendIndividualSignupEmail: (email): Promise<any> => {
            return UserService.resendIndividualSignupEmail(email)
                .catch(err => storeHelper.handleError({ error: err, rethrow: false }));
        },
        getContributionLimits () {
            return UserService.getLegalContributionLimitsByPlanType()
                .then(r => {
                    this.setContributionLimits(r.data);
                }).catch(error => storeHelper.handleError({ error, rethrow: true }));
        }
    }
});

